var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 2.13292C0.710974 1.42195 1.42195 0.710974 2.13292 0C5.26121 3.09274 8.38949 6.22102 11.4822 9.3493C14.6105 6.22102 17.7388 3.09274 20.8671 0C21.5781 0.710974 22.289 1.42195 23 2.13292C19.8717 5.26121 16.7434 8.38949 13.6507 11.4822C16.7434 14.6105 19.8717 17.7388 23 20.8671C22.289 21.5781 21.5781 22.289 20.8671 23C17.7388 19.8717 14.6105 16.7434 11.4822 13.6507C8.38949 16.7434 5.26121 19.8717 2.13292 23C1.42195 22.289 0.710974 21.5781 0 20.8671C3.09274 17.7388 6.22102 14.6105 9.3493 11.4822C6.22102 8.38949 3.09274 5.26121 0 2.13292Z","fill":"#F95D5D"}));
}

Close.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = Close;

Close.default = Close;
